import React from 'react';

import { Space } from '@mantine/core';
import { DetailsSettings } from 'pages/Settings/SettingTabs/GeneralSettingsTab/DetailsSettings';
import { PasswordSettings } from 'pages/Settings/SettingTabs/GeneralSettingsTab/PasswordSettings';
import { SettingsSectionWrapper } from 'pages/Settings/SettingTabs/SettingsSectionWrapper';
import { useTranslation } from 'react-i18next';

export function GeneralSettingsTab() {
  const { t } = useTranslation();
  return (
    <>
      <SettingsSectionWrapper title={t('SETTINGS.GENERAL.DETAILS.TITLE')}>
        <DetailsSettings />
      </SettingsSectionWrapper>
      <Space h={40} />
      <SettingsSectionWrapper title={t('SETTINGS.PASSWORD.HINT')} maw={500}>
        <PasswordSettings />
      </SettingsSectionWrapper>
      <Space h={40} />
    </>
  );
}
